import { FunctionComponent } from 'react';
import { ReactComponent as UserIcon } from 'assets/icons/User.svg';
import { useAuth } from 'providers/auth';

interface UserButtonProps {}

const UserButton: FunctionComponent<UserButtonProps> = () => {
  const { user } = useAuth();
  return (
    <div className='flex items-center'>
      <div className='flex w-10 h-10 rounded-full bg-theme-border text-theme-shadow mr-2'>
        <UserIcon className='m-auto' />
      </div>
      <div>{user?.name?.split(' ')[0]}</div>
    </div>
  );
};

export default UserButton;
